<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
    page: {
        title: 'Log in',
        meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
    },
    components: { Layout },
    data() {
        return {
            username: '',
            password: '',
            authError: null,
            tryingToLogIn: false,
            isAuthError: false,
        }
    },
    computed: {
        placeholders() {
            return process.env.NODE_ENV === 'production'
                ? {}
                : {
                    username: 'Use "admin" to log in with the mock API',
                    password: 'Use "password" to log in with the mock API',
                }
        },
    },
    methods: {
        ...authMethods,
        // Try to log the user in with the username
        // and password they provided.
        tryToLogIn() {
            this.tryingToLogIn = true
            // Reset the authError if it existed.
            this.authError = null
            return this.logIn({
                username: this.username,
                password: this.password,
            })
                .then((token) => {
                    this.tryingToLogIn = false
                    this.isAuthError = false
                    // Redirect to the originally requested page, or to the home page
                    if (token.is_password_change === 1) {
                        this.tryingToLogIn = true
                        this.$router.push({ name: "updatePassword" });
                    } else {
                        this.$router.push(this.$route.query.redirectFrom || { name: "home" });
                    }
                })
                .catch((error) => {
                    this.tryingToLogIn = false;
                    this.authError = error.response ? error.response.data : "";
                    this.isAuthError = true;
                })
        },
    },
}
</script>

<template>
    <Layout>
        <div class="row login">
            <div class="col-lg-8 col-md-6 col-sm-12">
                <p class="welcome">WELCOME!</p>
                <p class="project-name"><span>T</span>raining Management System</p>
            </div>
            <div class=" col-lg-4 col-md-6 col-sm-12">
                <div class="login-section">
                    <div class="row">
                        <div class="col-12">
                            <div class="login-header">
                                <img class="logo" src="@assets/images/logo-dark.png" alt="" />
                            </div>
                            <b-alert v-model="isAuthError" variant="danger" dismissible>
                                {{ authError }}
                            </b-alert>

                            <b-form @submit.prevent="tryToLogIn">
                                <b-input-group style="color: #000; margin-bottom: 18px;" id="input-group-1" label=""
                                    label-for="input-1">
                                    <template #prepend>
                                        <b-input-group-text>
                                            <i class="bi bi-envelope-fill"></i>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input id="input-1" v-model="username" type="email" required placeholder=""
                                        class="form-control form-control">
                                    </b-form-input>
                                </b-input-group>

                                <b-input-group style="color: #000; margin-bottom: 18px;" id="input-group-2" label=""
                                    label-for="input-2">
                                    <template #prepend>
                                        <b-input-group-text>
                                            <i class="bi bi-person-fill-lock"></i>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input id="input-2" v-model="password" type="password" required placeholder=""
                                        class="form-control form-control">
                                    </b-form-input>
                                </b-input-group>

                                <div class="auth-btns">
                                    <b-form-group id="button-group">
                                        <b-button type="submit" variant="secondary" class="btn btn-sm login-button">
                                            <b-spinner small v-show="tryingToLogIn" label="Spinning"
                                                style="margin-bottom: 2px; margin-right: 5px;"></b-spinner>
                                            Log In
                                        </b-button>
                                    </b-form-group>

                                    <b-form-group id="button-group">
                                        <b-button type="button" variant="primary" class="btn btn-sm forget-password">

                                            <router-link :to="{ name: 'forget-password' }">
                                                <b>Forgot password</b>
                                            </router-link>
                                        </b-button>
                                    </b-form-group>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss">
.login {
    height: 100vh;
    padding: 125px;
    display: flex;
    align-items: center;

    .login-header {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 15px 0 40px 0;
    }

    @media screen and (max-width: 768px) {
        padding: 50px;
    }
}

.logo {
    width: 125px;
    height: 125px;
    display: inline;
    border-radius: 50%;
    margin-right: 15px;
}

.welcome {
    color: #fff;
    font-family: 'Cerebri Sans,sans-serif';
    font-size: 35px;

    @media screen and (max-width: 992px) {
        font-size: 25px;
    }

    @media screen and (max-width: 850px) {
        font-size: 18px;
    }
}

.project-name {
    font-weight: 700;
    color: #fff;
    font-size: 70px;
    margin-bottom: 0;
    font-family: sans-serif;
    transition-duration: 0.1s;

    @media screen and (max-width: 992px) {
        font-size: 50px;
    }

    @media screen and (max-width: 850px) {
        font-size: 35px;
    }

    @media screen and (max-width: 768px) {
        margin-bottom: 20px;
        font-size: 28px;
    }
}

.login-section {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    background-color: #218b9db0;
    color: #fff;
    border-radius: 5px;
    // padding: 5px 20px;
    height: 500px;
    width: 350px;
    padding: 40px 25px;
    transition-duration: 0.1s;

    @media screen and (max-width: 992px) {
        font-size: 25px;
        height: 450px;
        width: 325px;
    }

    @media screen and (max-width: 768px) {
        height: 400px;
        padding: 15px;
        margin: auto;
    }
}

.login-page-image {
    vertical-align: middle;
    border-style: none;
    width: 100%;
    height: 500px;
    border-radius: 3px 0 0 3px;
}

.input-group-text {
    border-radius: 20px !important;
    position: absolute;
    top: 4px;
    left: 3px;
    z-index: 99;
    padding: 4px 8px;
    background-color: #4a6d73;
    border-color: #4a6d73;
    color: #fff;
}

.input-group>.form-control {
    border-radius: 20px !important;
    padding-left: 40px;
    background-color: #d5edf3;
    color: #222;
    border: 0;
}

.auth-btns {
    display: flex;
    justify-content: space-between;

    .login-button {
        padding: 4px 50px;
        border-radius: 20px;
        background-color: #218b9db0;
        border-color: #a9c6cd7d;

        &:hover,
        &:active,
        &:focus {
            background-color: #d5edf3 !important;
            border-color: #a9c6cd7d !important;
            color: #333 !important;
        }
    }

    .forget-password {
        padding: 4px 10px;
        border-radius: 20px;
        background-color: #218b9db0;
        border-color: #a9c6cd7d;
        font-weight: 300;

        &:hover,
        &:active {
            background-color: #d5edf3 !important;
            border-color: #d5edf3 !important;
            color: #333 !important;
        }

        a {
            color: #fff;

            &:hover,
            &:active {
                color: #333;
            }
        }
    }
}
</style>
